var questions = {
	"pages": [{
			"number": 1,
			"title": "Your Goals and Motivation",
			"header": "Tell us about your personal health goals and motivators.",
			"questions": [{
					"key": "goals",
					"type": "checkbox",
					"text": "Help us identify your main health goals by selecting from the options below.",
					"microcopy": "You may select more than one, check all that apply",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Achieve and maintain a healthy weight",
							"value": "weight",
							"id": "achieve",
							"upsertKey": "goals_achieve"
						},
						{
							"index": 1,
							"text": "Prevent or manage a health condition (i.e. high blood pressure, abnormal cholesterol, or diabetes)",
							"value": "syndrome",
							"id": "prevent",
							"upsertKey": "goals_prevent"
						},
						{
							"index": 2,
							"text": "Maintain good health",
							"value": "health",
							"id": "maintain",
							"upsertKey": "goals_maintain"
						},
						{
							"index": 3,
							"text": "Healthy aging",
							"value": "aging",
							"id": "healthy",
							"upsertKey": "goals_healthy"
						},
						{
							"index": 4,
							"text": "Improve energy",
							"value": "energy",
							"id": "improve",
							"upsertKey": "goals_improve"
						},
						{
							"index": 5,
							"text": "Sleep better",
							"value": "sleep",
							"id": "sleep",
							"upsertKey": "goals_sleep"
						},
						{
							"index": 6,
							"text": "Manage stress",
							"value": "stress",
							"id": "manage",
							"upsertKey": "goals_manage"
						},
						{
							"index": 7,
							"text": "Increase physical activity",
							"value": "activity",
							"id": "increase",
							"upsertKey": "goals_increase"
						},
						{
							"index": 8,
							"text": "Improve my eating habits",
							"value": "eating",
							"id": "eatinghabits",
							"upsertKey": "goals_eatinghabits"
						}
					]
				},
				{
					"key": "motivators",
					"id": "motivators",
					"upsertKey": "motivators_freetext",
					"type": "text",
					"text": "Please tell us about some of the factors that are motivating you to make changes in your health at this time.",
					"microcopy": "For example: live longer, feel more energetic, look better in clothes, etc.",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required.",
						"regex": "^(?!.*[<>]).*$",
						"rgxerror": "Invalid entry. Some special characters are not allowed."
					}
				},
				{
					"key": "weight-goal",
					"id": "weight-goal",
					"upsertKey": "weight-goal_freetext",
					"type": "text",
					"text": "How much would you like to weigh (in pounds) after completing the program?",
					"placeholder": "Enter weight here",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required.",
						"regex": "^(|[0-9]|[1-9][0-9]|[1-9][0-9][0-9])$",
						"rgxerror": "Invalid entry. Must be a numeric value between 1 and 999, and must not contain decimals.",
						"inputmask": "9{1,3}",
						"min": "1",
						"max": "999",
						"mmerror": "Value must be between 1 and 999"
					}
				},
				{
					"key": "weight-options",
					"type": "radio",
					"text": "Have you tried to lose weight in the past?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"branching": [{
						"value": "yes",
						"branch": "weight-lost"
					}],
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "weight-options_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "weight-options_no"
						}
					]
				},
				{
					"key": "weight-lost",
					"type": "radio",
					"text": "How much weight did you lose (lbs)?",
					"options": {
						"noBR": false,
						"visible": false
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "1 - 5 lbs",
							"value": "1-5",
							"id": "onetofivelbs",	
							"upsertKey": "weight-lost_onetofivelbs"
						},
						{
							"index": 1,
							"text": "5 - 10 lbs",
							"value": "5-10",
							"id": "fivetotenlbs",	
							"upsertKey": "weight-lost_fivetotenlbs"
						},
						{
							"index": 2,
							"text": "10 - 15 lbs",
							"value": "10-15",
							"id": "tentofifteenlbs",	
							"upsertKey": "weight-lost_tentofifteenlbs"
						},
						{
							"index": 3,
							"text": "15+ lbs",
							"value": "15+",
							"id": "abovefifteen",	
							"upsertKey": "weight-lost_abovefifteen"
						}
					]
				},
				{
					"key": "mindset",
					"type": "radio",
					"text": "Please indicate how you feel about making improvements to your health at this time.",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "I am not prepared to make changes",
							"value": "not-prepared",
							"id": "notprepared" ,
							"upsertKey": "mindset_notprepared"
						},
						{
							"index": 1,
							"text": "I am not sure about making changes",
							"value": "not-sure",
							"id": "notsure" ,
							"upsertKey": "mindset_notsure"
						},
						{
							"index": 2,
							"text": "I plan to change",
							"value": "plan",
							"id": "plan" ,
							"upsertKey": "mindset_plan"
						},
						{
							"index": 3,
							"text": "I am already making changes",
							"value": "already-changing",
							"id": "already" ,
							"upsertKey": "mindset_already"
						}
					]
				},
				{
					"key": "eat",
					"type": "radio",
					"text": "Are you ready to make a change in your eating habits?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"branching": [{
						"value": "yes",
						"branch": "habits"
					}],
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "eat_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "eat_no"
						},
						{
							"index": 2,
							"text": "Don't know",
							"value": "dont-know",
							"id": "notknow",
							"upsertKey": "eat_notknow"
						}
					]
				},
				{
					"key": "habits",
					"type": "radio",
					"text": "Have you already started making some changes to improve your eating habits?",
					"options": {
						"noBR": false,
						"visible": false
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"branching": [{
						"value": "no",
						"branch": "intend"
					}],
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "habits_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "habits_no"
						}
					]
				},
				{
					"key": "intend",
					"type": "radio",
					"text": "Are you intending to make some dietary changes in the next six months with the goal of improving your health?",
					"options": {
						"noBR": false,
						"visible": false
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "intend_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "intend_no"
						},
						{
							"index": 2,
							"text": "Don't know",
							"value": "dont-know",
							"id": "notknow",
							"upsertKey": "intend_notknow"
						}
					]
				}
			]
		},
		{
			"number": 2,
			"title": "Your Nutrition",
			"header": "There's just a bit more to cover regarding nutrition.",
			"questions": [{
					"key": "water",
					"type": "radio",
					"text": "How many glasses of water do you drink on a daily basis?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "6 - 8",
							"value": "6-8",
							"id": "sixtoeight",
							"upsertKey": "water_sixtoeight"
						},
						{
							"index": 1,
							"text": "4 - 5",
							"value": "4-5",
							"id": "fourtofive",
							"upsertKey": "water_fourtofive"
						},
						{
							"index": 2,
							"text": "1 - 3",
							"value": "1-3",
							"id": "onetothree",
							"upsertKey": "water_onetothree"
						},
						{
							"index": 3,
							"text": "None",
							"value": "none",
							"id": "none",
							"upsertKey": "water_none"
						}
					]
				},
				{
					"key": "three-meals",
					"type": "radio",
					"text": "On a typical day, do you eat breakfast, lunch, and dinner?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"branching": [{
						"value": "no",
						"branch": "tell-us"
					}],
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "three-meals_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "three-meals_no"
						}
					]
				},
				{
					"key": "tell-us",
					"id": "freetext",
					"upsertKey": "tell-us_freetext",
					"type": "text",
					"text": "If No, tell us which meal you tend to skip",
					"options": {
						"noBR": false,
						"visible": false
					},
					"validation": {
						"required": true,
						"rqerror": "Which meal do you skip?",
						"regex": "^(?!.*[<>]).*$",
						"rgxerror": "Invalid entry. Some special characters are not allowed."
					},
				},
				{
					"key": "diet",
					"type": "radio",
					"text": "What type of diet do you prefer?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Standard",
							"value": "standard",
							"id": "standard",
							"upsertKey": "diet_standard"
						},
						{
							"index": 1,
							"text": "Vegetarian",
							"value": "vegetarian",
							"id": "vegetarian",
							"upsertKey": "diet_vegetarian"
						},
						{
							"index": 2,
							"text": "Vegan",
							"value": "vegan",
							"id": "vegan",
							"upsertKey": "diet_vegan"
						}
					]
				},
				{
					"key": "allergies",
					"type": "checkbox",
					"text": "Do you have any of the following food allergies/intolerances?",
					"microcopy": "You may select more than one; check all that apply.",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"branching": [{
						"value": "other",
						"branch": "other-allergies"
					}],
					"fields": [{
							"index": 0,
							"text": "Nuts",
							"value": "nuts",
							"id": "nuts",
							"upsertKey": "allergies_nuts"
						},
						{
							"index": 1,
							"text": "Dairy",
							"value": "dairy",
							"id": "dairy",
							"upsertKey": "allergies_dairy"
						},
						{
							"index": 2,
							"text": "Gluten",
							"value": "gluten",
							"id": "gluten",
							"upsertKey": "allergies_gluten"
						},
						{
							"index": 3,
							"text": "Fish",
							"value": "fish",
							"id": "fish",
							"upsertKey": "allergies_fish"
						},
						{
							"index": 4,
							"text": "Shellfish",
							"value": "shellfish",
							"id": "shellfish",
							"upsertKey": "allergies_shellfish"
						},
						{
							"index": 5,
							"text": "Soy",
							"value": "soy",
							"id": "soy",
							"upsertKey": "allergies_soy"
						},
						{
							"index": 6,
							"text": "Eggs",
							"value": "egg",
							"id": "eggs",
							"upsertKey": "allergies_eggs"
						},
						{
							"index": 7,
							"text": "I do not have food allergies or intolerances",
							"value": "none",
							"id": "none",
							"upsertKey": "allergies_none"
						},
						{
							"index": 8,
							"text": "Other",
							"value": "other",
							"id": "other",
							"upsertKey": "allergies_other"
						}
					]
				},
				{
					"key": "other-allergies",
					"id": "freetext",
					"upsertKey": "other-allergies_freetext",
					"type": "text",
					"text": "Please enter any other allergies",
					"options": {
						"noBR": false,
						"visible": false
					},
					"validation": {
						"required": true,
						"rqerror": "List food products to which you are allergic",
						"regex": "^(?!.*[<>]).*$",
						"rgxerror": "Invalid entry. Some special characters are not allowed."
					}
				}
			]
		},
		{
			"number": 3,
			"title": "Your Well-Being",
			"header": "Let's talk about stress factors.",
			"questions": [{
					"key": "stress-level",
					"type": "radio",
					"text": "Rate your average stress level in the past two weeks. (1 is not stressed and 10 is extremely stressed)",
					"options": {
						"noBR": false,
						"visible": true,
						"horizontal": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "1",
							"value": "1",
							"id": "one",
							"upsertKey": "stress-level_one"
						},
						{
							"index": 1,
							"text": "2",
							"value": "2",
							"id": "two",
							"upsertKey": "stress-level_two"
						},
						{
							"index": 2,
							"text": "3",
							"value": "3",
							"id": "three",
							"upsertKey": "stress-level_three"
						},
						{
							"index": 3,
							"text": "4",
							"value": "4",
							"id": "four",
							"upsertKey": "stress-level_four"
						},
						{
							"index": 4,
							"text": "5",
							"value": "5",
							"id": "five",
							"upsertKey": "stress-level_five"
						},
						{
							"index": 5,
							"text": "6",
							"value": "6",
							"id": "six",
							"upsertKey": "stress-level_six"
						},
						{
							"index": 6,
							"text": "7",
							"value": "7",
							"id": "seven",
							"upsertKey": "stress-level_seven"
						},
						{
							"index": 7,
							"text": "8",
							"value": "8",
							"id": "eight",
							"upsertKey": "stress-level_eight"
						},
						{
							"index": 8,
							"text": "9",
							"value": "9",
							"id": "nine",
							"upsertKey": "stress-level_nine"
						},
						{
							"index": 9,
							"text": "10",
							"value": "10",
							"id": "ten",
							"upsertKey": "stress-level_ten"
						}
					]
				},
				{
					"key": "manage-stress",
					"type": "checkbox",
					"text": "How do you manage stress?",
					"microcopy": "You may select more than one; check all that apply.",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Going out with or talking to friends",
							"value": "friends",
							"id": "goingout",
							"upsertKey": "manage-stress_goingout"
						},
						{
							"index": 1,
							"text": "Physical activity",
							"value": "activity",
							"id": "physicalactivity",
							"upsertKey": "manage-stress_physicalactivity"
						},
						{
							"index": 2,
							"text": "Spending time with your family",
							"value": "family",
							"id": "spendingtime",
							"upsertKey": "manage-stress_spendingtime"
						},
						{
							"index": 3,
							"text": "Planning time off to relax and do something enjoyable (a hobby, read, massage, etc.)",
							"value": "hobby",
							"id": "planningtime",
							"upsertKey": "manage-stress_planningtime"
						},
						{
							"index": 4,
							"text": "Having a drink of alcohol (wine, liquor, beer)",
							"value": "drink",
							"id": "drinkalcohol",
							"upsertKey": "manage-stress_drinkalcohol"
						},
						{
							"index": 5,
							"text": "None of the above",
							"value": "none",
							"id": "none",
							"upsertKey": "manage-stress_none"
						}
					]
				},
				{
					"key": "actual-sleep",
					"type": "radio",
					"text": "On average, how many hours of sleep do you get?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "5 hours or less",
							"value": "5less",
							"id": "lessthanfive",
							"upsertKey": "actual-sleep_lessthanfive"	
						},
						{
							"index": 1,
							"text": "6 hours",
							"value": "6",
							"id": "six",
							"upsertKey": "actual-sleep_six"	
						},
						{
							"index": 2,
							"text": "7 to 9 hours",
							"value": "7-9",
							"id": "seventonine",
							"upsertKey": "actual-sleep_seventonine"	
						},
						{
							"index": 3,
							"text": "10 hours or more",
							"value": "10plus",
							"id": "morethanten",
							"upsertKey": "actual-sleep_morethanten"	
						}
					]
				},
				{
					"key": "sleep-quality",
					"type": "radio",
					"text": "Rate your sleep quality in the past 2 weeks. (1 is extremely poor and 10 is excellent)",
					"options": {
						"noBR": false,
						"visible": true,
						"horizontal": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "1",
							"value": "1",
							"id": "one",
							"upsertKey": "sleep-quality_one"
						},
						{
							"index": 1,
							"text": "2",
							"value": "2",
							"id": "two",
							"upsertKey": "sleep-quality_two"
						},
						{
							"index": 2,
							"text": "3",
							"value": "3",
							"id": "three",
							"upsertKey": "sleep-quality_three"
						},
						{
							"index": 3,
							"text": "4",
							"value": "4",
							"id": "four",
							"upsertKey": "sleep-quality_four"
						},
						{
							"index": 4,
							"text": "5",
							"value": "5",
							"id": "five",
							"upsertKey": "sleep-quality_five"
						},
						{
							"index": 5,
							"text": "6",
							"value": "6",
							"id": "six",
							"upsertKey": "sleep-quality_six"
						},
						{
							"index": 6,
							"text": "7",
							"value": "7",
							"id": "seven",
							"upsertKey": "sleep-quality_seven"
						},
						{
							"index": 7,
							"text": "8",
							"value": "8",
							"id": "eight",
							"upsertKey": "sleep-quality_eight"
						},
						{
							"index": 8,
							"text": "9",
							"value": "9",
							"id": "nine",
							"upsertKey": "sleep-quality_nine"
						},
						{
							"index": 9,
							"text": "10",
							"value": "10",
							"id": "ten",
							"upsertKey": "sleep-quality_ten"
						}
					]
				},
				{
					"key": "energy",
					"type": "radio",
					"text": "Rate your average energy level in the past two weeks. (1 is no energy and 10 is high energy)",
					"options": {
						"noBR": false,
						"visible": true,
						"horizontal": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "1",
							"value": "1",
							"id": "one",
							"upsertKey": "energy_one"
						},
						{
							"index": 1,
							"text": "2",
							"value": "2",
							"id": "two",
							"upsertKey": "energy_two"
						},
						{
							"index": 2,
							"text": "3",
							"value": "3",
							"id": "three",
							"upsertKey": "energy_three"
						},
						{
							"index": 3,
							"text": "4",
							"value": "4",
							"id": "four",
							"upsertKey": "energy_four"
						},
						{
							"index": 4,
							"text": "5",
							"value": "5",
							"id": "five",
							"upsertKey": "energy_five"
						},
						{
							"index": 5,
							"text": "6",
							"value": "6",
							"id": "six",
							"upsertKey": "energy_six"
						},
						{
							"index": 6,
							"text": "7",
							"value": "7",
							"id": "seven",
							"upsertKey": "energy_seven"
						},
						{
							"index": 7,
							"text": "8",
							"value": "8",
							"id": "eight",
							"upsertKey": "energy_eight"
						},
						{
							"index": 8,
							"text": "9",
							"value": "9",
							"id": "nine",
							"upsertKey": "energy_nine"
						},
						{
							"index": 9,
							"text": "10",
							"value": "10",
							"id": "ten",
							"upsertKey": "energy_ten"
						}
					]
				}
			]
		},
		{
			"number": 4,
			"title": "Your Physical Activity",
			"header": "Tell us about your activity levels.",
			"questions": [{
					"key": "physical-activity",
					"type": "radio",
					"text": "Are you physically active?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"branching": [{
						"value": "yes",
						"branch": "physical-activity-150min"
					}],
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "physical-activity_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "physical-activity_no"
						}
					]
				},
				{
					"key": "physical-activity-150min",
					"type": "radio",
					"text": "Are you currently exercising at least 150 minutes per week?",
					"options": {
						"noBR": false,
						"visible": false
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "physical-activity-150min_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "physical-activity-150min_no"
						}
					]
				},
				{
					"key": "start-continue",
					"type": "radio",
					"text": "Are you ready to start or continue with physical activity?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Yes! Set me up with an exercise routine that will help me reach my health goals.",
							"value": "yes",
							"id": "yes",
							"upsertKey": "start-continue_yes"
						},
						{
							"index": 1,
							"text": "No, at this point, I recognize that exercise is important, but I am not ready to become more active.",
							"value": "no",
							"id": "no",
							"upsertKey": "start-continue_no"
						}
					]
				},
				{
					"key": "exercise-intensity",
					"type": "radio",
					"text": "Rate your level of exercise intensity",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Low intensity",
							"value": "low-intensity",
							"id": "low",
							"upsertKey": "exercise-intensity_low"
						},
						{
							"index": 1,
							"text": "Medium intensity",
							"value": "medium-intensity",
							"id": "medium",
							"upsertKey": "exercise-intensity_medium"
						},
						{
							"index": 2,
							"text": "High intensity",
							"value": "high-intensity",
							"id": "high",
							"upsertKey": "exercise-intensity_high"
						}
					]
				},
				{
					"key": "equipment",
					"type": "radio",
					"text": "To personalize your program, tell us about the equipment that you would like us to incorporate into your physical activity plan.",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Regular exercise machines and weights that are found in most gyms, health clubs, or home gyms",
							"value": "regular",
							"id": "regularexercise",
							"upsertKey": "equipment_regularexercise"
						},
						{
							"index": 1,
							"text": "Do not incorporate machines, and only include weights such as dumbbells/barbells, and equipment like tubing/resistance bands or medicine balls",
							"value": "basic",
							"id": "nomachine",
							"upsertKey": "equipment_nomachine"
						},
						{
							"index": 2,
							"text": "I do not have access to any equipment, so I would only like to include exercises that involve body weight",
							"value": "none",
							"id": "noaccess",
							"upsertKey": "equipment_noaccess"
						}
					]
				},
				{
					"key": "cardio-activity",
					"id": "freetext",
					"upsertKey": "cardio-activity_freetext",
					"type": "text",
					"text": "Please let us know what kind of cardiovascular activities you would like us to include in your physical activity plan",
					"microcopy": "For example: walking, elliptical, dancing, water aerobics, etc.",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required.",
						"regex": "^(?!.*[<>]).*$",
						"rgxerror": "Invalid entry. Some special characters are not allowed."
					}
				}
			]
		},
		{
			"number": 5,
			"title": "Your Health",
			"header": "Let's discuss your health.",
			"questions": [{
					"key": "medical-condition",
					"type": "checkbox",
					"text": "Do you have any medical conditions we should be aware of?",
					"microcopy": "Please indicate if any of the following applies to you:",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Asthma",
							"value": "asthma",
							"id": "asthma",
							"upsertKey": "medical-condition_asthma"
						},
						{
							"index": 1,
							"text": "Cancer (chemotherapy or radiation in the last 12 months)",
							"value": "cancer",
							"id": "cancer",
							"upsertKey": "medical-condition_cancer"
						},
						{
							"index": 2,
							"text": "Celiac disease",
							"value": "celiac disease",
							"id": "celiac",
							"upsertKey": "medical-condition_celiac"
						},
						{
							"index": 3,
							"text": "Chronic bronchitis or emphysema (COPD)",
							"value": "chronic-bronchitis-or-emphysema-copd",
							"id": "bronchitis",
							"upsertKey": "medical-condition_bronchitis"
						},
						{
							"index": 4,
							"text": "Chronic fatigue syndrome",
							"value": "chronic-fatigue-syndrome",
							"id": "fatigue",
							"upsertKey": "medical-condition_fatigue"
						},
						{
							"index": 5,
							"text": "Crohn's disease",
							"value": "crohns-disease",
							"id": "crohn",
							"upsertKey": "medical-condition_crohn"
						},
						{
							"index": 6,
							"text": "Cystic fibrosis",
							"value": "cystic-fibrosis",
							"id": "cystic",
							"upsertKey": "medical-condition_cystic"
						},
						{
							"index": 7,
							"text": "Diabetes type I",
							"value": "diabetes-type-i",
							"id": "diabetes1",
							"upsertKey": "medical-condition_diabetes1"
						},
						{
							"index": 8,
							"text": "Diabetes type II",
							"value": "diabetes-type-ii",
							"id": "diabetes2",
							"upsertKey": "medical-condition_diabetes2"
						},
						{
							"index": 9,
							"text": "Fibromyalgia",
							"value": "fibromyalgia",
							"id": "fibromyalgia",
							"upsertKey": "medical-condition_fibromyalgia"
						},
						{
							"index": 10,
							"text": "Gastritis",
							"value": "gastritis",
							"id": "gastric",
							"upsertKey": "medical-condition_gastric"
						},
						{
							"index": 11,
							"text": "Gastroesophageal reflux disease (GERD)",
							"value": "gastroesophageal-reflux-disease-gerd",
							"id": "gaestroesophageal",
							"upsertKey": "medical-condition_gaestroesophageal"
						},
						{
							"index": 12,
							"text": "Glaucoma",
							"value": "glaucoma",
							"id": "glaucoma",
							"upsertKey": "medical-condition_glaucoma"
						},
						{
							"index": 13,
							"text": "Heart attack (aneurysm, stroke, congestive heart failure, angina, hemorrhage, claudication-leg clot, or any other kind of cardiovascular disease/incident in the last 12 months)",
							"value": "heart-attack",
							"id": "heartattack",
							"upsertKey": "medical-condition_heartattack"
						},
						{
							"index": 14,
							"text": "High blood pressure (hypertension)",
							"value": "highbloodpressure",
							"id": "highbloodpressure",
							"upsertKey": "medical-condition_highbloodpressure"
						},
						{
							"index": 15,
							"text": "High cholesterol (hypercholesterolemia)",
							"value": "highcholesterol",
							"id": "highcholesterol",
							"upsertKey": "medical-condition_highcholesterol"
						},
						{
							"index": 16,
							"text": "Hyperthyroidism (overactive thyroid)",
							"value": "hyperthyroidism",
							"id": "tyroidoveractive",
							"upsertKey": "medical-condition_thyroidoveractive"
						},
						{
							"index": 17,
							"text": "Hypothyroidism (underactive thyroid)",
							"value": "hypothyroidism",
							"id": "thyroidunderactive",
							"upsertKey": "medical-condition_thyroidunderactive"
						},
						{
							"index": 18,
							"text": "HIV or AIDS",
							"value": "hiv-or-aids",
							"id": "hivaids",
							"upsertKey": "medical-condition_hivaids"
						},
						{
							"index": 19,
							"text": "Iron deficiency (iron deficiency anemia)",
							"value": "iron-deficiency",
							"id": "irondefficiancy",
							"upsertKey": "medical-condition_irondefficiancy"
						},
						{
							"index": 20,
							"text": "Kidney disease (kidney failure, nephritis, nephrotic syndrome, active kidney stones)",
							"value": "kidney-disease",
							"id": "kidneydisease",
							"upsertKey": "medical-condition_kidneydisease"
						},
						{
							"index": 21,
							"text": "Liver disease (acute hepatitis, cirrhosis or other)",
							"value": "liver-disease",
							"id": "liverdisease",
							"upsertKey": "medical-condition_liverdisease"
						},
						{
							"index": 22,
							"text": "Myasthenia gravis or any other serious musculoskeletal disease",
							"value": "myasthenia-gravis-musculoskeletal-disease",
							"id": "myasthenia",
							"upsertKey": "medical-condition_myasthenia"
						},
						{
							"index": 23,
							"text": "Nervous system disorder (Parkinson’s Disease, multiple sclerosis, Huntington’s disease, amyotrophic lateral sclerosis (ALS/Lou Gehrig’s disease), cerebral palsy, muscular dystrophy, paralysis, epilepsy or other)",
							"value": "nervous-system-disorder",
							"id": "nervoussystem",
							"upsertKey": "medical-condition_nervoussystem"
						},
						{
							"index": 24,
							"text": "Osteoarthritis",
							"value": "osteoarthritis",
							"id": "osteoarthritis",
							"upsertKey": "medical-condition_osteoarthritis"
						},
						{
							"index": 25,
							"text": "Osteoporosis (low bone density)",
							"value": "osteoporosis",
							"id": "osteoporosis",
							"upsertKey": "medical-condition_osteoporosis"
						},
						{
							"index": 26,
							"text": "Sleep apnea",
							"value": "sleep-apnea",
							"id": "sleepapnea",
							"upsertKey": "medical-condition_sleepapnea"
						},
						{
							"index": 27,
							"text": "Ulcerative colitis",
							"value": "ulcerative-colitis",
							"id": "colitis",
							"upsertKey": "medical-condition_colitis"
						},
						{
							"index": 28,
							"text": "Vitamin B12 deficiency",
							"value": "vitamin-b12-deficiency",
							"id": "b12",
							"upsertKey": "medical-condition_b12"
						},
						{
							"index": 29,
							"text": "None of the above",
							"value": "none",
							"id": "none",
							"upsertKey": "medical-condition_none"
						}
					]
				},
				{
					"key": "psychiatric-condition",
					"type": "radio",
					"text": "Do you have any psychological conditions we should be aware of? (e.g., Major Depression, Bipolar Disorder, Panic or Post Traumatic Stress Disorder)",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"branching": [{
						"value": "yes",
						"branch": "psychiatric-condition-treatment"
					}],
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "psychiatric-condition_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "psychiatric-condition_no"
						}
					]
				},
				{
					"key": "psychiatric-condition-treatment",
					"type": "radio",
					"text": "Are you currently being treated (e.g., therapy and/or medication) or followed by a health professional (e.g., doctor, psychologist, psychiatrist, therapist) for the condition(s)?",
					"options": {
						"noBR": false,
						"visible": false
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "psychiatric-condition-treatment_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "psychiatric-condition-treatment_no"
						}
					]
				},
				{
					"key": "eating-disorder",
					"type": "radio",
					"text": "Have you ever been diagnosed with an Eating Disorder (Anorexia, Bulimia, Binge Eating Disorder)?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "eating-disorder_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "eating-disorder_no"
						}
					]
				},
				{
					"key": "laxatives",
					"type": "radio",
					"text": "Do you regularly use laxatives, diuretics, extreme calorie restriction, or self-induced vomiting to help you manage your weight?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "laxatives_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "laxatives_no"
						}
					]
				},
				{
					"key": "prescription",
					"type": "radio",
					"text": "Do you currently take any prescription medications?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"branching": [{
						"value": "yes",
						"branch": "condition-medication"
					}],
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "prescription_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "prescription_no"
						}
					]
				},
				{
					"key": "condition-medication",
					"id": "freetext",
					"upsertKey": "condition-medication_freetext",
					"type": "text",
					"text": "What condition(s) are the medications for?",
					"options": {
						"noBR": false,
						"visible": false
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required.",
						"regex": "^(?!.*[<>]).*$",
						"rgxerror": "Invalid entry. Some special characters are not allowed."
					}
				},
				{
					"key": "smoke",
					"type": "radio",
					"text": "Do you smoke?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "smoke_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "smoke_no"
						}
					]
				},
				{
					"key": "diabetes-in-family",
					"type": "radio",
					"text": "Do you have a mother, father, sister, or brother with diabetes?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "diabetes-in-family_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "diabetes-in-family_no"
						}
					]
				},
				{
					"key": "days-unable-to-work",
					"type": "radio",
					"text": "In the last 3 months, how many days were you unable to work due to an illness or injury?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "1 - 3 days",
							"value": "1-3",
							"id": "onetothree",
							"upsertKey": "days-unable-to-work_onetothree"
						},
						{
							"index": 1,
							"text": "4 - 6 days",
							"value": "4-6",
							"id": "fourtosix",
							"upsertKey": "days-unable-to-work_fourtosix"
						},
						{
							"index": 2,
							"text": "7 - 10 days",
							"value": "7-10",
							"id": "seventoten",
							"upsertKey": "days-unable-to-work_seventoten"
						},
						{
							"index": 3,
							"text": "10+ days",
							"value": "10+",
							"id": "aboveten",
							"upsertKey": "days-unable-to-work_aboveten"
						},
						{
							"index": 4,
							"text": "none",
							"value": "0",
							"id": "none",
							"upsertKey": "days-unable-to-work_none"
						}
					]
				},
				{
					"key": "doctor-visits",
					"type": "radio",
					"text": "In the last 3 months, how many times did you visit your doctor or health care provider due to health concerns?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "1 - 3 times",
							"value": "1-3",
							"id": "onetothree",
							"upsertKey": "doctor-visits_onetothree"
						},
						{
							"index": 1,
							"text": "4 - 6 times",
							"value": "4-6",
							"id": "fourtosix",
							"upsertKey": "doctor-visits_fourtosix"
						},
						{
							"index": 2,
							"text": "7+ times",
							"value": "7+",
							"id": "aboveseven",
							"upsertKey": "doctor-visits_aboveseven"
						},
						{
							"index": 3,
							"text": "none",
							"value": "0",
							"id": "none",
							"upsertKey": "doctor-visits_none"
						}
					]
				},
				{
					"key": "injuries",
					"type": "checkbox",
					"text": "Indicate if you currently have any physical injuries in the following areas:",
					"microcopy": "You may select more than one; check all that apply.",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Back and/or neck",
							"value": "back-neck",
							"id": "back",
							"upsertKey": "injuries_back"
						},
						{
							"index": 1,
							"text": "Hip",
							"value": "hip",
							"id": "hip",
							"upsertKey": "injuries_hip"
						},
						{
							"index": 2,
							"text": "Knee",
							"value": "knee",
							"id": "knee",
							"upsertKey": "injuries_knee"
						},
						{
							"index": 3,
							"text": "Ankle and/or foot",
							"value": "ankle-foot",
							"id": "ankle",
							"upsertKey": "injuries_ankle"
						},
						{
							"index": 4,
							"text": "Shoulder",
							"value": "shoulder",
							"id": "shoulder",
							"upsertKey": "injuries_shoulder"
						},
						{
							"index": 5,
							"text": "Elbow and/or wrist",
							"value": "elbow-wrist",
							"id": "elbow",
							"upsertKey": "injuries_elbow"
						},
						{
							"index": 6,
							"text": "None ",
							"value": "none",
							"id": "none",
							"upsertKey": "injuries_none"
						}
					]
				},
				{
					"key": "condition",
					"type": "radio",
					"text": "Has your doctor ever said that you have a medical condition and you should only do physical activity recommended by a doctor?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "condition_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "condition_no"
						}
					]
				},
				{
					"key": "reason",
					"type": "radio",
					"text": "Do you know of any other reasons why you should not do physical activity?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"branching": [{
						"value": "yes",
						"branch": "what-reason"
					}],
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "reason_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "reason_no"
						}
					]
				},
				{
					"key": "what-reason",
					"id": "freetext",
					"upsertKey": "what-reason_freetext",
					"type": "text",
					"text": "Please tell us about the reason(s).",
					"options": {
						"noBR": false,
						"visible": false
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required.",
						"regex": "^(?!.*[<>]).*$",
						"rgxerror": "Invalid entry. Some special characters are not allowed."
					}
				}
			]
		},
		{
			"number": 6,
			"title": "Your Profile",
			"header": "Nearly there! Let's complete your Personal Profile.",
			"questions": [{
					"key": "current-weight",
					"id": "freetext",
					"upsertKey": "current-weight_freetext",
					"type": "text",
					"text": "What is your current weight (in pounds)?",
					"placeholder": "Enter weight here",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required.",
						"regex": "^(|[0-9]|[1-9][0-9]|[1-9][0-9][0-9])$",
						"rgxerror": "Invalid entry. Must be a numeric value between 1 and 999, and must not contain decimals.",
						"inputmask": "9{1,3}",
						"min": "1",
						"max": "999",
						"mmerror": "Value must be between 1 and 999"
					}
				},
				{
					"key": "height-feet",
					"id": "freetext",
					"upsertKey": "height-feet_freetext",
					"type": "text",
					"text": "What is your current height (feet/inches)?",
					"label": "feet",
					"placeholder": "Enter height here",
					"options": {
						"noBR": true,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required.",
						"regex": "^(|[0-9])$",
						"rgxerror": "Invalid entry. Must be a numeric value between 4 and 9, and must not contain decimals.",
						"inputmask": "9",
						"min": "4",
						"max": "7",
						"mmerror": "Value must be between 4 and 7"
					}
				},
				{
					"key": "height-inches",
					"id": "freetext",
					"upsertKey": "height-inches_freetext",
					"type": "text",
					"text": "Height in inches",
					"label": "inches",
					"placeholder": "Enter height here",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required.",
						"regex": "^(|[0-9]|[1-9][0-9])$",
						"rgxerror": "Invalid entry. Must be a numeric value between 0 and 11, and must not contain decimals.",
						"inputmask": "9{1,2}",
						"min": "0",
						"max": "11",
						"mmerror": "Value must be between 0 and 11"
					}
				},
				{
					"key": "gender",
					"type": "radio",
					"text": "What gender do you identify with?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Male",
							"value": "male",
							"id": "male",
							"upsertKey": "gender_male"
						},
						{
							"index": 1,
							"text": "Female",
							"value": "female",
							"id": "female",
							"upsertKey": "gender_female"
						},
						{
							"index": 1,
							"text": "Prefer not to say",
							"value": "prefer not to say",
							"id": "prefernottosay",
							"upsertKey": "gender_prefernottosay"
						},
						{
							"index": 1,
							"text": "Other",
							"value": "other",
							"id": "other",
							"upsertKey": "gender_other"
						}
					]
				},
				{
					"key": "sex",
					"type": "radio",
					"text": "What is your biological sex?",
					"microcopy": "We use this information to help make a caloric recommendation.",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"branching": [{
							"value": "female",
							"branch": "pregnant"
						},
						{
							"value": "female",
							"branch": "breast-feeding"
						},
						{
							"value": "female",
							"branch": "gest-diabetes"
						}
					],
					"fields": [{
							"index": 0,
							"text": "Male",
							"value": "male",
							"id": "male",
							"upsertKey": "sex_male"
						},
						{
							"index": 1,
							"text": "Female",
							"value": "female",
							"id": "female",
							"upsertKey": "sex_female"
						}
					]
				},
				{
					"key": "pregnant",
					"type": "radio",
					"text": "Are you pregnant?",
					"options": {
						"noBR": false,
						"visible": false
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "pregnant_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "pregnant_no"
						}
					]
				},
				{
					"key": "breast-feeding",
					"type": "radio",
					"text": "Are you currently breast feeding?",
					"options": {
						"noBR": false,
						"visible": false
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "breast-feeding_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "breast-feeding_no"
						}
					]
				},
				{
					"key": "gest-diabetes",
					"type": "radio",
					"text": "Have you ever been diagnosed with gestational diabetes? (This is a condition of high blood sugar that can occur during pregnancy)?",
					"options": {
						"noBR": false,
						"visible": false
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "gest-diabetes_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "gest-diabetes_no"
						}
					]
				},
				{
					"key": "heritage",
					"type": "checkbox",
					"text": "Which of the following best represents your racial or ethnic heritage? You may select more than one; check all that apply.",
					"microcopy": "This question is for research purposes which may be used in the future to deliver a more personalized program.",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Black or African American",
							"value": "black-afro-american",
							"id": "africanamerican",
							"upsertKey": "heritage_africanamerican"
						},
						{
							"index": 1,
							"text": "American Indian or Alaska Native",
							"value": "american-indian-alaska-native",
							"id": "americanindian",
							"upsertKey": "heritage_americanindian"
						},
						{
							"index": 2,
							"text": "Asian American",
							"value": "asian",
							"id": "asian",
							"upsertKey": "heritage_asian"
						},
						{
							"index": 3,
							"text": "Hispanic / Latino American",
							"value": "hispanic-latino",
							"id": "hispanic",
							"upsertKey": "heritage_hispanic"
						},
						{
							"index": 4,
							"text": "Native Hawaiian or Pacific Islander",
							"value": "native-hawaiian-pacific-islander",
							"id": "hawaiian",
							"upsertKey": "heritage_hawaiian"
						},
						{
							"index": 5,
							"text": "White",
							"value": "white",
							"id": "white",
							"upsertKey": "heritage_white"
						},
						{
							"index": 6,
							"text": "Prefer not to answer",
							"value": "none",
							"id": "prefernottosay",
							"upsertKey": "heritage_prefernottosay"
						}
					]
				},
				{
					"key": "marital",
					"type": "radio",
					"text": "Marital status",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Married",
							"value": "married",
							"id": "married",
							"upsertKey": "marital_married"
						},
						{
							"index": 1,
							"text": "Common-law",
							"value": "common-law",
							"id": "common",
							"upsertKey": "marital_common-law"
						},
						{
							"index": 2,
							"text": "Divorced",
							"value": "divorced",
							"id": "divorced",
							"upsertKey": "marital_divorced"
						},
						{
							"index": 3,
							"text": "Separated",
							"value": "seperated",
							"id": "seperated",
							"upsertKey": "marital_seperated"
						},
						{
							"index": 4,
							"text": "Single",
							"value": "single",
							"id": "single",
							"upsertKey": "marital_single"
						},
						{
							"index": 5,
							"text": "Prefer not to answer",
							"value": "none",
							"id": "prefernottosay",
							"upsertKey": "marital_prefernottosay"
						}
					]
				},
				{
					"key": "occupation",
					"id": "freetext",
					"upsertKey": "occupation_freetext",
					"type": "text",
					"text": "What is your current occupation?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required.",
						"regex": "^(?!.*[<>]).*$",
						"rgxerror": "Invalid entry. Some special characters are not allowed."
					}
				},
				{
					"key": "tracker",
					"type": "radio",
					"text": "Do you own an activity tracker (i.e. Apple Watch or FitBit)?",
					"options": {
						"noBR": false,
						"visible": true
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"branching": [{
							"value": "yes",
							"branch": "tracker-name"
						},
						{
							"value": "yes",
							"branch": "tracker-synch"
						}
					],
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "tracker_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "tracker_no"
						}
					]
				},
				{
					"key": "tracker-name",
					"id": "freetext",
					"upsertKey": "tracker-name_freetext",
					"type": "text",
					"text": "What kind of tracker are you using?",
					"options": {
						"noBR": false,
						"visible": false
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required.",
						"regex": "^(?!.*[<>]).*$",
						"rgxerror": "Invalid entry. Some special characters are not allowed."
					}
				},
				{
					"key": "tracker-synch",
					"type": "radio",
					"text": "Is your tracker synched to Google Fit or Apple Health?",
					"options": {
						"noBR": false,
						"visible": false
					},
					"validation": {
						"required": true,
						"rqerror": "A value is required."
					},
					"fields": [{
							"index": 0,
							"text": "Yes",
							"value": "yes",
							"id": "yes",
							"upsertKey": "tracker-synch_yes"
						},
						{
							"index": 1,
							"text": "No",
							"value": "no",
							"id": "no",
							"upsertKey": "tracker-synch_no"
						},
						{
							"index": 2,
							"text": "Don't Know",
							"value": "notknow",
							"id": "notknow",
							"upsertKey": "tracker-synch_notknow"
						}
					]
				}
			]
		}
	]
}

export default questions